/* eslint-disable */
import { useEffect, useState } from "react";

import { cn } from "../../common/helpers/formatters";

interface ToggleButtonProps {
  defaultValue?: number | string;
  className?: string;
  options: { value: number | string; text: string }[];
  onChange?: (value: number | string) => void;
}

const ToggleButton = ({
  defaultValue,
  className,
  options,
  onChange,
}: ToggleButtonProps) => {
  const [selectedValue, setSelectedValue] = useState<number | string | undefined>(defaultValue);

  useEffect(() => {
    setSelectedValue(defaultValue);
  }, [defaultValue]);

  const handleClick = (value: number | string) => {
    setSelectedValue(value);
    if (onChange) {
      onChange(value);
    }
  };

  if (!options || options.length === 0) return null;

  return (
    <div className={`btn-toggle-group ${className}`}>
      {options.map((option) => (
        <button
          className={cn("btn-toggle", option.value === selectedValue && "selected")}
          key={option.value}
          onClick={() => handleClick(option.value)}
          type="button"
        >
          {option.text}
        </button>
      ))}
    </div>
  );
};

export default ToggleButton;
